
export interface IConfirmLugasCoolingOffLogoutDialogOptions {
    onAccept: () => Promise<void>;
    onReject: () => Promise<void>;
}

export enum DialogResult {
    Accepted,
    Rejected
}

export interface IDialogFactoryService {
    showConfirmLugasCoolingOffLogout(options: IConfirmLugasCoolingOffLogoutDialogOptions): Promise<DialogResult>;
}